// src/lib/unsavedChanges.js
//
// Ticket 118. One flag for "something on this screen is not saved yet", read by every way off the screen.
//
// The admin's buy-links editor sets it while it holds changes that are not saved (setUnsaved). Anything
// that would leave the screen asks first (okToLeave): the Books tabs and page buttons, the admin sidebar
// and the phone's bottom bar (handleNav in AdminPortal.jsx), and the site's top bar (Navbar.jsx).
// Two ways off cannot be reached by a click and are covered here:
//   - the browser's Back and Forward buttons (popstate). The app uses BrowserRouter, where React Router's
//     useBlocker is not available, so this listener is registered when the file is first loaded, which is
//     before the router's own, and swallows the event until the question is answered. If the answer is no
//     the browser is sent back to where it was and the router never hears of it. If yes, the event is sent
//     again and the router takes it.
//   - closing or reloading the tab (beforeunload). A browser shows its own box there and allows no text of ours.
//
// The words are the editor's (LINK_WORDS.closeAnyway); the editor hands them in, so they are written once.

let question = null;   // what to ask, or null when nothing is unsaved
let homeIdx = null;    // where the history was when the first change was made
let restoring = false; // true while we send the browser back to homeIdx

const idxNow = () => (typeof window !== 'undefined' && window.history.state && typeof window.history.state.idx === 'number' ? window.history.state.idx : null);

export function setUnsaved(on, text) {
  if (on) {
    if (question === null) homeIdx = idxNow();
    question = text;
  } else {
    question = null;
    homeIdx = null;
  }
}

export const hasUnsaved = () => question !== null;

// True when it is fine to leave: nothing is unsaved, or the person said yes. It leaves the flag alone:
// the editor clears it when it goes. So a yes that leaves the editor on screen is asked again at the
// next way off, and the change is never dropped without a question.
export function okToLeave() {
  return question === null || window.confirm(question);
}

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', e => {
    if (restoring) { restoring = false; e.stopImmediatePropagation(); return; }
    if (question === null || homeIdx === null) return;       // nothing to protect, or no way to put the browser back
    const now = idxNow();
    if (now === null || now === homeIdx) return;
    e.stopImmediatePropagation();
    if (window.confirm(question)) {
      setUnsaved(false);
      window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
    } else {
      restoring = true;
      window.history.go(homeIdx - now);
    }
  });
  window.addEventListener('beforeunload', e => {
    if (question === null) return;
    e.preventDefault();
    e.returnValue = '';
  });
}
